import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SnackbarProvider, useSnackbar } from "notistack";
import { styled } from "@mui/styles";
import makeStyles from "@mui/styles/makeStyles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Modal, Typography, Paper } from "@mui/material";
import CardButton from "../shared/cardButton";
import ButtonBlue from "../shared/buttonBlue";
import UnicornLoading from "../assets/loading.gif";
import SiteService from "../../../services/site.service";
import DriverRouteDayService from "../../../services/driverRouteDay.service";
import { getDriverRouteDayByIdDriver } from "../../../actions/driverRouteDay";
import { getLocationAndVehicleUsage } from "../../../actions/locationVehicle";
import { startGpsTracking } from "../../../actions/gps";
import CarConnectionModal from "./ChoseDeliverySampleCar";
import ServiceTypeModal from "./ServiceTypeModal";
import BetweenSiteCarService from "../../../services/betweenSiteCar.service";
import { display } from "@mui/system";

const useStyles = makeStyles((theme) => ({
  Modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  Paper: {
    width: "500px",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const DivCoverReturn = styled("div")({
  width: "100%",
  height: "calc(100% - 64px)",
  backgroundColor: "white",
  display: "flex",
  position: "relative",
  justifyContent: "center",
  marginLeft: "0px",
});

const BackgroundImg = styled("img")({
  position: "absolute",
  width: "100%",
  height: "calc(100% - 64px)",
  opacity: "0.3",
  zIndex: "0",
});

const CheckCircleIconStyled = styled(CheckCircleIcon)({
  fontSize: "56px",
  color: "white",
});

const Content = styled("div")({
  width: "100%",
  height: "100%",
  zIndex: "1",
  display: "flex",
  justifyContent: "center",
});

const DemoNotification = () => {
  return (
    <ButtonBlue
      variant="contained"
      onClick={() => {
        BetweenSiteCarService.postNewBetweenSiteCar({
          toPlace: 7,
          gettingPlace: 1,
          idUser: 7,
          phoneRequester: "1234",
        });
      }}
      sx={{ width: "200px" }}
    >
      Demo Notification
    </ButtonBlue>
  );
};

const HomeDriver = (props) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const { user: currentUser } = useSelector((state) => state.auth);
  const { result: Driver } = useSelector((state) => state.driverRouteDay);
  const locationVehicle = useSelector(
    (state) => state.locationVehicle
  );

  const [count, setCount] = useState(0);
  const [openVehicleModal, setOpenVehicleModal] = useState(false);
  const [openServiceTypeModal, setOpenServiceTypeModal] = useState(false);
  const [gpsModalOpen, setGpsModalOpen] = useState(true);
  const [allowGpsConnectionOpen, setAllowGpsConnectionOpen] = useState(false);
  const gpsData = useSelector((state) => state.gps);

  useEffect(() => {
    if (gpsData && gpsData.status) {
      if (gpsData.status === "กำลังเชื่อมต่อGPS") {
        setGpsModalOpen(true);
      } else if (gpsData.status === "เชื่อมต่อGPSสำเร็จ") {
        setGpsModalOpen(false);
        enqueueSnackbar("เชื่อมต่อ GPS สำเร็จ", { variant: "success" });

        // DriverRouteDayService.getDriverRouteDayByIdDriver(
        //   currentUser.idUser,
        //   "2022-08-27"
        // ).then((res) => {
        //   console.log("res.data : ", res.data);
        //   if (!res.data.bedTime) {
        //     props.history.push("authencar");
        //   } else {
        //     dispatch(getDriverRouteDayByIdDriver(currentUser.idUser, "2022-08-27"));
        //   }
        // });
      } else if (gpsData.status === "เชื่อมต่อGPSไม่สำเร็จ") {
        setGpsModalOpen(false);
        setAllowGpsConnectionOpen(true);
        enqueueSnackbar("เชื่อมต่อ GPS ไม่สำเร็จ", { variant: "error" });
      }
    }
  }, [gpsData?.status]);

  useEffect(() => {
    if (currentUser.idUser && !locationVehicle.result) {
      dispatch(getLocationAndVehicleUsage(currentUser.idUser));
    }
  }, [dispatch, currentUser]);

  const dataCard = [
    {
      Icon: <CheckCircleIconStyled />,
      Name: "PLAN",
      path: "/plan",
    },
    {
      Image: "./assets/Image/Icon/map.png",
      Name: "MAP",
      path: "/map",
    },
    // {
    //   Image: "./assets/Image/Icon/site.png",
    //   Name: "รับส่งระหว่าง Site",
    //   path: "/map-between-site",
    // },
    {
      Image: "./assets/Image/Icon/alert.png",
      Name: "แจ้งเหตุฉุกเฉิน",
      path: "/emergency",
    },
    {
      Image: "./assets/Image/Icon/driverTopic.png",
      Name: "เลือกงานที่กำลังให้บริการ",
    },
    {
      Image: "./assets/Image/Icon/car.png",
      Name: "เลือกรถที่กำลังใช้งาน",
    },
    {
      Image: "./assets/Image/Icon/repeat.png",
      Name: "รายการจองของฉัน",
      path: "/myListForDriver/cross_area_car_booking",
    },
  ];

  const onClickCard = (path, Name) => {
    if (Name === "เลือกรถที่กำลังใช้งาน") {
      setOpenVehicleModal(true);
    } else if (Name === "เลือกงานที่กำลังให้บริการ") {
      setOpenServiceTypeModal(true);
    } else {
      props.history.push(path);
    }
  };

  return (
    <DivCoverReturn className="page">
      <BackgroundImg
        src="./assets/background/carpark_home.jpg"
        alt="backgroundImage"
      />
      <Content>
        <CardButton dataCard={dataCard} onClickCard={onClickCard} />
        {/* Uncomment below for betweenSiteCar notification testing  */}
        {/* <DemoNotification/> */}
      </Content>
      {gpsModalOpen && (
        <Modal
          className={`${classes.Modal}`}
          open={gpsModalOpen}
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              setGpsModalOpen(false);
            }
          }}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <Paper className={`${classes.Paper}`}>
            <Typography>กำลังเชื่อมต่อ GPS</Typography>
            <img
              src={UnicornLoading}
              alt="Loading..."
              style={{ width: "300px" }}
            />
          </Paper>
        </Modal>
      )}
      {allowGpsConnectionOpen && (
        <Modal
          className={`${classes.Modal}`}
          open={allowGpsConnectionOpen}
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              setAllowGpsConnectionOpen(false);
            }
          }}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <Paper className={`${classes.Paper}`}>
            <Typography style={{ textAlign: "center", paddingBottom: "12px" }}>
              เราจำเป็นต้องเข้าถึงตำแหน่งของคุณ เพื่อแสดงตำแหน่งคนขับรถบนแผนที่
            </Typography>
            <Typography
              style={{
                textAlign: "center",
                paddingBottom: "20px",
                fontSize: "20px",
              }}
            >
              กรุณาอนุญาตการเข้าถึงตำแหน่งเพื่อใช้คุณสมบัตินี้
            </Typography>
            <img
              src="./assets/Image/Icon/map.png"
              alt="GPS Permission"
              style={{ width: "100px", height: "100px", marginBottom: "20px" }}
            />
            <ButtonBlue
              variant="contained"
              onClick={() => setAllowGpsConnectionOpen(false)}
            >
              เข้าใจแล้ว
            </ButtonBlue>
          </Paper>
        </Modal>
      )}
      <ServiceTypeModal
        open={openServiceTypeModal}
        onClose={() => setOpenServiceTypeModal(false)}
        userId={currentUser.idUser}
      />
      {/* For Delivery Sample Shuttle */}
      {gpsData && (
        <CarConnectionModal
          open={openVehicleModal}
          onClose={() => setOpenVehicleModal(false)}
          userId={currentUser.idUser}
          lat={gpsData.coordinates.lat}
          lng={gpsData.coordinates.lng}
        />
      )}
    </DivCoverReturn>
  );
};

export default HomeDriver;
